export function ZeroOrder(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || 222}
      height={props.height || 222}
      viewBox="0 0 222 222"
      {...props}
    >
      <defs>
        <style>{'.prefix__b{fill:#9b9b9b}'}</style>
      </defs>
      <g transform="translate(-45.08 -204.08)">
        <circle
          cx={111}
          cy={111}
          r={111}
          transform="translate(45.08 204.08)"
          fill="#fbfbfb"
        />
        <path
          className="prefix__b"
          d="M149.095 326.393l2.582-10.489 8.762 2.157-2.582 10.489z"
        />
        <path
          className="prefix__b"
          d="M171.937 252.318a35.546 35.546 0 1026.045 43.011 35.551 35.551 0 00-26.045-43.011zm-14.875 60.547a26.8 26.8 0 1132.412-19.627 26.79 26.79 0 01-32.409 19.627z"
        />
        <path
          className="prefix__b"
          d="M132.447 379.266c-.746 3.037 2.156 6.36 6.483 7.423 4.326 1.062 8.437-.537 9.184-3.573l12.27-49.949c.747-3.036-2.156-6.36-6.482-7.422-4.327-1.062-8.439.537-9.185 3.573z"
        />
        <path
          d="M137.435 280.448a26.8 26.8 0 1119.63 32.417 26.8 26.8 0 01-19.63-32.417z"
          style={{
            mixBlendMode: 'screen',
            isolation: 'isolate',
          }}
          fill="#fff"
          opacity={0.869}
        />
      </g>
    </svg>
  );
}
